import { apiGet, apiPut } from './http'

export const getConfiguration = async buildingId =>
  apiGet(`/accounting/configuration/${buildingId}`, {
    auth: true,
    fallbackMessage: 'Error al obtener la configuracion contable.',
  })

export const saveConfiguration = async (buildingId, payload) =>
  apiPut(`/accounting/configuration/${buildingId}`, payload, {
    auth: true,
    fallbackMessage: 'Error al guardar la configuracion contable.',
  })
